
import universal, { setHasBabelPlugin } from '/app/node_modules/react-universal-component/dist/index.js'


setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

const t_0 = universal(import('../src/containers/404'), universalOptions)
const t_1 = universal(import('../src/containers/homepage'), universalOptions)
const t_2 = universal(import('../src/containers/client'), universalOptions)
const t_3 = universal(import('../src/containers/job'), universalOptions)
const t_4 = universal(import('../src/containers/category'), universalOptions)
const t_5 = universal(import('../src/containers/microsite'), universalOptions)


// Template Map
export default {
  '../src/containers/404': t_0,
'../src/containers/homepage': t_1,
'../src/containers/client': t_2,
'../src/containers/job': t_3,
'../src/containers/category': t_4,
'../src/containers/microsite': t_5
}

export const notFoundTemplate = "../src/containers/404"
